/**
 * EmptyState — shared placeholder for empty data tables / grids. Used across
 * monitor, employees, leaves, travel logs, etc.
 */
export default function EmptyState({ icon: Icon, title, subtitle }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-gray-400">
      {Icon && <Icon size={48} className="mb-3 opacity-20" />}
      {title && <p className="font-medium text-gray-500">{title}</p>}
      {subtitle && <p className="text-sm mt-1">{subtitle}</p>}
    </div>
  );
}
